module.exports = __webpack_public_path__ + "img/1440.8ffa56c3.jpg";